<template>
    <div class="vrm-form__fieldset-item">
        <label v-if="title" class="sg-textfield-label" :class="{ 'sg-required': required }">
            <span class="sg-textfield-label-caption">{{ title }}</span>
            <i v-if="tooltip" v-tooltip.bottom="tooltip" class="sg-vrm-icon_061_info-round-16px" />
        </label>
        <div :class="{ 'vrm-indicator-input': dataIndicator }" :data-indicator="dataIndicator">
            <input
                ref="input"
                v-model="value"
                :type="type"
                :disabled="disabled"
                class="sg-element"
                v-bind="$attrs"
                :required="required"
                :class="{ 'sg-error': showErrors }"
                :placeholder="placeholder"
                @input="vrmValidate"
                @focusin="toggleFocus"
                @focusout="toggleFocus"
            />
        </div>
        <div v-if="showErrors || hasWarnings" class="vrm-form_input-errors">
            <span :class="{ 'sg-input-error': hasErrors, 'sg-input-warning': hasWarnings }">
                {{ validationMessage }}
            </span>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmInfoTooltip from '@/vue/components/shared/VrmInfoTooltip';
import { VALIDATION_TYPE } from '@/vue/constants/validation-types';

@Component({
    inheritAttrs: false,
    components: { VrmInfoTooltip },
})
@AngularLocaleBundle('form')
export default class VrmTextField extends Vue {
    @Prop()
    title;

    @Prop({ type: Boolean, default: false })
    required;

    @Model('input')
    model;

    @Prop({ type: String, default: 'text' })
    type;

    @Prop({ type: String, default: '' })
    tooltip;

    @Prop({ type: Boolean, default: false })
    indicator;

    @Prop({ type: Boolean, default: false })
    disabled;

    @Prop({
        type: String,
        default: '',
    })
    placeholder;

    @Prop({ type: String, default: '' })
    dataIndicator;
    // List of check objects with property check containing a check function, property error containing the error.
    @Prop({
        type: Array,
        default: () => [],
        validator(list) {
            return list.every(({ check, message }) => {
                return _.isFunction(check) && _.isString(message);
            });
        },
    })
    checks;

    @Prop({ type: Boolean, default: false })
    hideValidationMessageOnFocus;

    focused = false;

    toggleFocus() {
        this.focused = !this.focused;
    }

    valuePostedThisTick = false;
    validationMessage = false;
    validationMessageType = false;

    get value() {
        return this.model;
    }

    set value(newValue) {
        this.valuePostedThisTick = true;
        this.$emit('input', newValue);
        this.$nextTick(() => {
            this.valuePostedThisTick = false;
        });
    }

    vrmValidate() {
        //validate after form has been submitted only option
        this.validationMessage = false;
        this.validationMessageType = false;
        const value = this.valuePostedThisTick ? this.$refs.input.value : this.value;
        const valid = value === 0 || value === '0' || !!value;
        if (this.required && !valid) {
            this.validationMessage = this.$t('form.required');
            this.validationMessageType = VALIDATION_TYPE.ERROR;
            return false;
        }
        for (let i = 0; i < this.checks.length; i++) {
            const { check, message, type } = this.checks[i];
            if (!check(value)) {
                this.validationMessage = this.$t(message);
                this.validationMessageType = type;
                return false;
            }
        }
        return true;
    }

    get hasErrors() {
        return this.validationMessageType === VALIDATION_TYPE.ERROR;
    }

    get showErrors() {
        return (
            this.validationMessageType === VALIDATION_TYPE.ERROR &&
            (!this.hideValidationMessageOnFocus || !this.focused)
        );
    }

    get hasWarnings() {
        return this.validationMessageType === VALIDATION_TYPE.WARNING;
    }
}
</script>
